import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/* global window */
import { injectScript } from 'atc-js';
import _get from 'lodash/get';
import { isQA } from '../../utilities';
import { pathByBrandEnv } from './getPixallPathByBrandEnv';
var pixallLibrary = null;
export default function getPixall(_x) {
  return _getPixall.apply(this, arguments);
}
function _getPixall() {
  _getPixall = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_temp) {
    var _ref, _ref$brand, brand, _ref$disablePixall, disablePixall, scriptPath, env;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _ref = _temp === void 0 ? {} : _temp, _ref$brand = _ref.brand, brand = _ref$brand === void 0 ? 'atc' : _ref$brand, _ref$disablePixall = _ref.disablePixall, disablePixall = _ref$disablePixall === void 0 ? false : _ref$disablePixall;
          if (!disablePixall) {
            _context.next = 3;
            break;
          }
          return _context.abrupt("return", []);
        case 3:
          if (!pixallLibrary) {
            _context.next = 5;
            break;
          }
          return _context.abrupt("return", pixallLibrary);
        case 5:
          scriptPath = '';
          env = isQA() ? 'qa' : 'prod';
          scriptPath = _get(pathByBrandEnv, [brand, env], pathByBrandEnv.atc.prod);
          pixallLibrary = Promise.resolve(window.Pixall && window._pxan ? window._pxan : injectScript(scriptPath).then(function () {
            return window._pxan;
          }));
          return _context.abrupt("return", pixallLibrary);
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getPixall.apply(this, arguments);
}